import get from 'lodash/get';
import { push } from 'connected-react-router';
import { getCurrentBreadcrumb } from '../redux/reducers/helper';
import { PAGE_ACTIVITY_LOGGER } from '../redux/types';

export const pageRouter = (dispatch, route) => {
	dispatch(push(`/${route}`));
}

export default function router(dispatch, uid, cjEventId, response) {
  const currentStatus = get(response, 'data.response.other_params.current_status', '');
  const breadcrumbs = get(response, 'data.response.breadcrumbs', []);
  const currentBreadcrumb = getCurrentBreadcrumb(breadcrumbs);
  const pageActivityLogger =['completed','signature']
  
  const redirectUrl = get(response, 'data.response.other_params.next_button_redirect_url', false);

  // This uid is a payment-bridge application the backend linked back to an original
  // application (see MemberDetailsIoService::linkOfferSessionToOldApplication). Bounce
  // the browser back to the original application, preserving whatever query params the
  // payment vendor appended on its own return redirect — only the uid value changes.
  const linkedOriginalApplicationUid = get(response, 'data.response.other_params.linkedOriginalApplicationUid', false);
  if (linkedOriginalApplicationUid) {
    const params = new URLSearchParams(window.location.search);
    params.set('uid', linkedOriginalApplicationUid);
    window.location.replace(`${window.location.pathname}?${params.toString()}`);
    return true;
  }

  if(pageActivityLogger.indexOf(currentStatus)>-1){
    dispatch({
      type:PAGE_ACTIVITY_LOGGER,
      params:{ currentStatus },
    })
	if(redirectUrl) {
		// This fires synchronously — the browser is already navigating away, so (like the
		// linkedOriginalApplicationUid case above) skip the SPA push below and signal the
		// caller to skip its own follow-up state dispatches too.
		window.location.replace(redirectUrl);
		return true;
	}
  }

  // Processing screen redirection — deferred via setTimeout, so no hard navigation has
  // happened yet at this point. The SPA push below (showing the Loader page) and the
  // caller's state dispatches are still needed to render the interim wait; don't return
  // true here.
  if (currentStatus === 'processing') {
	if(redirectUrl) {
		setTimeout(() => {
			window.location.replace(redirectUrl);
		}, 5000);
	}
  }

  if (currentStatus === 'questions') {
	if(cjEventId) {
		dispatch(push(`/questions/${currentBreadcrumb.id}?uid=${uid}&cjevent=${cjEventId}`));
	} else {
		dispatch(push(`/questions/${currentBreadcrumb.id}?uid=${uid}`));
	}
  } else if (uid) {
	if(cjEventId) {
		dispatch(push(`/${currentStatus}?uid=${uid}&cjevent=${cjEventId}`));
	} else {
		dispatch(push(`/${currentStatus}?uid=${uid}`));
	}
  } else {
	dispatch(push(`/${currentStatus}`));
  }

  return false;
}
